import React from 'react';

function Header() {
  return (
    <header>
      <nav className="website-nav">
        <ul>
          <li><a className="home-link" href="/">Home</a></li>
          <li><a href="/app">Nutscaper</a></li>
          {/* Add other nav links here if any */}
        </ul>
      </nav>
    </header>
  );
}

export default Header; 